/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deltaText: NonNullable<unknown>, date: NonNullable<unknown> }} Profile_Weight_DeltaInputs */

const en_us2_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} since ${i?.date}`)
};

const pt_br2_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} desde ${i?.date}`)
};

const es_419_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} desde el ${i?.date}`)
};

const pt_pt2_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} desde ${i?.date}`)
};

const fr_fr2_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} depuis le ${i?.date}`)
};

const de_de2_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} seit ${i?.date}`)
};

const it_it2_profile_weight_delta = /** @type {(inputs: Profile_Weight_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} dal ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{deltaText} since {date}" |
*
* @param {Profile_Weight_DeltaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_delta = /** @type {((inputs: Profile_Weight_DeltaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_DeltaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_delta(inputs)
	if (locale === "es-419") return es_419_profile_weight_delta(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_delta(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_delta(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_delta(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_delta(inputs)
	return en_us2_profile_weight_delta(inputs)
});
export { profile_weight_delta as "profile.weight_delta" }